export default function Dashboard() {
  return (
    <div className="min-h-screen p-8">
      <h1 className="text-4xl font-bold gradient-text">Dashboard</h1>
      <p className="mt-4 text-star-white/70">Command center coming soon...</p>
    </div>
  )
}
